<template>
  <span v-text="text" />
</template>

<script>
import {
  IntervalMailSendingStatus,
  SendInterval,
} from '@/models/Report/IntervalReport'

const sendIntervalItems = [
  { value: SendInterval.DAILY, text: '毎日' },
  { value: SendInterval.WEEKLY, text: '毎週月曜日' },
  { value: SendInterval.MONTHLY, text: '毎月1日' },
]

export default {
  name: 'IntervalReportListSendInterval',
  props: {
    value: {
      type: String,
      default: '',
      validator(value) {
        return Object.values(SendInterval).includes(value)
      },
    },
    status: {
      type: String,
      default: '',
    },
  },
  computed: {
    text() {
      return this.status === IntervalMailSendingStatus.ACTIVE
        ? sendIntervalItems.find(item => item.value === this.value).text
        : '-'
    },
  },
}
</script>
